import { render, staticRenderFns } from "./ServicePlaceBranches.vue?vue&type=template&id=fafe080c&scoped=true&"
import script from "./ServicePlaceBranches.vue?vue&type=script&lang=js&"
export * from "./ServicePlaceBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafe080c",
  null
  
)

export default component.exports